/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { ThemedStyleFn, useStyles } from '~src/hooks/useStyles';
import BackgroungImage from '~src/assets/c_web_projekt_bg_gray.jpg';
import Logo from '~src/assets/c-web-logo-white.png';
import DarkLogo from '~src/assets/c-web-logo-darkgray.png';
import { useIntl } from 'react-intl';

/** Not Found page */
const NotFoundPage = () => {
  const style = useStyles(styleFn);
  const intl = useIntl();

  return (
    <div css={style.wrapper}>
      <div css={style.container}>
        <img src={Logo} alt="" css={style.logo} />
        <img src={DarkLogo} alt="" css={style.darkLogo} />
        <div css={style.whiteBox}>
          <h1 css={style.title}>404</h1>
          <p css={style.description}>
            {intl.formatMessage({ id: 'not-found-page' })}
          </p>
          <a
            css={style.link}
            target="_blank"
            href="https://c-web.dk"
            rel="noreferrer">
            {intl.formatMessage({ id: 'help-to-log-in' })}
          </a>
          <a
            css={style.link}
            target="_blank"
            href="https://c-web.dk"
            rel="noreferrer">
            {intl.formatMessage({ id: 'go-to' })}
          </a>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;

const styleFn: ThemedStyleFn = (theme) => ({
  wrapper: {
    width: '100%',
    height: '100vh',
    backgroundImage: `url(${BackgroungImage})`,
    backgroundSize: 'cover',
    display: 'flex',
    justifyContent: 'center',
  },
  container: {
    textAlign: 'center',
    padding: '0 25px',
    width: '100%',
    height: '100%',
    maxWidth: '1200px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    '@media (max-width: 600px)': {
      justifyContent: 'center',
    },
  },

  whiteBox: {
    maxWidth: '350px',
    height: '100vh',
    backgroundColor: theme.colors.white,
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  logo: {
    src: Logo,
    width: '200px',
    marginTop: '100px',
    '@media (max-width: 600px)': {
      display: 'none',
    },
  },
  darkLogo: {
    position: 'absolute',
    width: '200px',
    top: '30px',

    '@media (min-width: 601px)': {
      display: 'none',
    },
  },

  title: {
    fontSize: '50px',
  },
  description: {
    fontSize: '18px',
    color: theme.colors.black,
    lineHeight: '40px',
    fontWeight: 500,
  },
  link: {
    color: theme.colors.orange,
    marginTop: '15px',
    fontWeight: 600,
    fontSize: '18px',
    ':hover': {
      color: theme.colors.darkOrange,
    },
  },
});
